export default "__VITE_PUBLIC_ASSET__0ea7ad89__"